import React from 'react';
import { BookOpen, Zap, Heart, Shield, MessageCircle, AlertOctagon } from 'lucide-react';
const TOMOS = [{
  number: 1,
  title: 'Atención y foco inmediato',
  desc: 'Técnicas para recuperar la atención en segundos sin levantar la voz.',
  icon: Zap,
  color: 'bg-yellow-100 text-yellow-700'
}, {
  number: 2,
  title: 'Regulación emocional en el momento',
  desc: 'Qué hacer cuando hay enojo, ansiedad, llanto o tensión en clase.',
  icon: Heart,
  color: 'bg-red-100 text-red-700'
}, {
  number: 3,
  title: 'Motivación real y participación activa',
  desc: 'Cómo activar alumnos apagados sin exponerlos ni presionarlos.',
  icon: BookOpen,
  color: 'bg-blue-100 text-blue-700'
}, {
  number: 4,
  title: 'Conducta, límites y autoridad tranquila',
  desc: 'Poner límites claros sin gritar ni entrar en luchas de poder.',
  icon: Shield,
  color: 'bg-green-100 text-green-700'
}, {
  number: 5,
  title: 'Comunicación docente de alto impacto',
  desc: 'Qué decir, cómo decirlo y cuándo callar para que el aula funcione.',
  icon: MessageCircle,
  color: 'bg-purple-100 text-purple-700'
}, {
  number: 6,
  title: 'Intervenciones difíciles y casos reales',
  desc: 'Qué hacer cuando nada funciona y la clase se desborda.',
  icon: AlertOctagon,
  color: 'bg-orange-100 text-orange-700'
}];
export function ProductBreakdown() {
  return <section className="bg-gray-50 py-16 md:py-24" data-id="element-179">
      <div className="mx-auto max-w-6xl px-4" data-id="element-180">
        <h2 className="mb-4 text-center text-3xl font-bold text-gray-900 md:text-5xl" data-id="element-181">
          ¿Qué incluye el MEGA KIT?
        </h2>
        <p className="mb-12 text-center text-xl text-gray-600" data-id="element-182">
          📘 6 TOMOS PRÁCTICOS (PDF)
        </p>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-183">
          {TOMOS.map(tomo => <div key={tomo.number} className="group relative overflow-hidden rounded-xl bg-white p-8 shadow-lg transition-all hover:-translate-y-1 hover:shadow-xl border border-gray-100" data-id="element-184">
              <div className={`mb-6 inline-flex h-12 w-12 items-center justify-center rounded-lg ${tomo.color}`} data-id="element-185">
                <tomo.icon className="h-6 w-6" data-id="element-186" />
              </div>
              <h3 className="mb-2 text-lg font-bold text-gray-900" data-id="element-187">
                <span className="block text-sm font-semibold uppercase tracking-wider text-gray-500 mb-1" data-id="element-188">
                  Tomo {tomo.number}
                </span>
                {tomo.title}
              </h3>
              <p className="text-gray-600" data-id="element-189">{tomo.desc}</p>
              <div className="absolute bottom-0 left-0 h-1 w-full bg-gradient-to-r from-transparent via-gray-200 to-transparent opacity-0 transition-opacity group-hover:opacity-100" data-id="element-190"></div>
            </div>)}
        </div>

        <div className="mt-16 text-center" data-id="element-191">
          <div className="mx-auto max-w-2xl rounded-lg bg-blue-50 p-6 border border-blue-100" data-id="element-192">
            <p className="text-lg font-medium text-blue-900" data-id="element-193">
              Cada tomo está pensado para que:
            </p>
            <div className="mt-4 flex flex-wrap justify-center gap-2 md:gap-8 text-blue-800 font-bold" data-id="element-194">
              <span className="flex items-center gap-2" data-id="element-195">1. Lo abras</span>
              <span className="text-blue-300" data-id="element-196">→</span>
              <span className="flex items-center gap-2" data-id="element-197">
                2. Elijas la situación
              </span>
              <span className="text-blue-300" data-id="element-198">→</span>
              <span className="flex items-center gap-2" data-id="element-199">
                3. Apliques una técnica
              </span>
              <span className="text-blue-300" data-id="element-200">→</span>
              <span className="flex items-center gap-2" data-id="element-201">
                4. Sigas con la clase
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}